/* eslint-disable no-console */
/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-empty-function */

import { environment } from './environment';

type LogName = 'debug' | 'log' | 'info' | 'warn' | 'error';

type LogFunction = (message?: any, ...optionalParams: any[]) => void;

const noop: LogFunction = () => {};

function createLogFunction(name: LogName): LogFunction {
  return function () {
    console[name].apply(console, [`${name} ==> `, ...arguments]);
  };
}

const productionLogger = {
  debug: noop,
  log: noop,
  info: noop,
  warn: createLogFunction('warn'),
  error: createLogFunction('error'),
};

const normalLogger = {
  debug: createLogFunction('debug'),
  log: createLogFunction('log'),
  info: createLogFunction('info'),
  warn: createLogFunction('warn'),
  error: createLogFunction('error'),
};

export const logger =
  environment === 'production' ? productionLogger : normalLogger;
